import React from 'react';
import { useParams } from 'react-router-dom';

import { useAffiliationsListQuery } from 'generated/graphql';

import AffiliationsTable from './AffiliationsTable';
import AddAffiliationsBanner from './AddAffiliationsBanner';

const AffiliationsList = (): JSX.Element | null => {
  const { id: userId } = useParams();

  const { data, loading } = useAffiliationsListQuery({
    variables: { userId },
  });

  if (loading) {
    return null;
  }

  if (data?.affiliations.length) {
    return <AffiliationsTable data={data} />;
  }

  return <AddAffiliationsBanner />;
};

export default AffiliationsList;
